import {UserId} from 'records/User';
import {TeamId} from 'records/TeamId';
import {DepartmentId} from 'records/Department';
import {Moment} from 'moment/moment';
import {Int} from '@store/@types/util';
import {List} from 'immutable';

export enum UserAdminSortFields {
  DISPLAY_NAME = 'display_name',
  TEAM_NAME = 'team_name',
  EMAIL = 'email',
  LAST_LOGIN = 'last_login',
  ACTIVE = 'active',
  SLACK_ENABLED = 'slack_enabled',
  RECORD_SCHEDULED_CALLS = 'record_scheduled_calls',
  CALENDAR_CONNECTED = 'calendar_connected',
  HAS_CALLS = 'has_calls',
}

export interface FetchUserTableResponse {
  users: List<UserTableView>;
  total: Int;
}

export interface UserTableView {
  userId: UserId;
  displayName: string;
  teamId: TeamId;
  teamName: string;
  teamActive: boolean;
  departmentId: DepartmentId;
  email: string;
  lastLogin?: Moment;
  active: boolean;
  slackEnabled: boolean;
  hasCalls: boolean;
  calendarConnected: boolean;
  botAutoJoinExclusion: boolean;
}
